// make our action generators utility functions for ease of use. Practically there is no difference between
// this method and just calling dispatch({ type: '', payload: {} }) with the appropriate values
const hoverApartmentAction = payload => {
    return { type: 'HOVER_APT', payload };
};

export default hoverApartmentAction;


// WEBPACK FOOTER //
// ./src/actions/hoverApartmentAction.js